// extracted by css-extract-rspack-plugin
export default {"content":"W5jFl2s5D7QqvDmB","loader":"rXfx9JMFug8nOQC8"};